'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getReferralDescription = exports.getReferralBonus = undefined;

var _immutableHelper = require('../utils/immutableHelper');

var _userConstants = require('../users/userConstants');

var getReferralBonus = exports.getReferralBonus = function getReferralBonus(referral) {
    return (0, _immutableHelper.prop)('cards', referral) || _userConstants.CONTENT_LIMIT_REFERRAL_MULTIPLIER;
};

var getReferralDescription = exports.getReferralDescription = function getReferralDescription(referral) {
    return (0, _immutableHelper.prop)('description', referral);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/referrals/referralUtil.js
// module id = 2286
// module chunks = 0